export const ROOM_LABEL_TEXT = {
    id: 'oe.rooms.label',
    description: 'Field label text',
    defaultMessage: 'Room Label',
};

export const HOST_CONNECTION_TEXT = {
    id: 'oe.rooms.hostConnection',
    description: 'Label text',
    defaultMessage: 'Host Connection',
};

export const ROOM_DATA_IS_BEING_SAVED_TEXT = {
    id: 'oe.rooms.roomDataIsBeingSaved',
    description: 'Preloader message text',
    defaultMessage: 'Room data is being saved, please wait...',
};

export const ROOM_DATA_IS_LOADING_TEXT = {
    id: 'oe.rooms.roomDataIsLoading',
    description: 'Preloader message text',
    defaultMessage: 'Room data is loading, please wait...',
};

export const ROOM_LABEL_MAX_LENGTH_TEXT = {
    id: 'oe.room.labelMaxLength',
    description: 'Error label text',
    defaultMessage: 'Maximum label length is {length} symbols',
};

export const V2_CONNECTIONS_TEXT = {
    message: 'V2 Connections are {suffix}',
    id: 'oe.rooms.v2Connections',
    description: 'Label text',
};

export const SHOULD_NOT_BEFORE_START_TEXT = {
    description: 'Validation error message',
    defaultMessage: 'End date should not be before the start date',
    id: 'oe.room.shouldNotBeforeStart',
};

export const INVALID_START_TIME_OR_END_TIME_TEXT = {
    id: 'oe.meeting.invalidStartTimeOrEndTime',
    defaultMessage: 'Invalid Start Time or End Time',
    description: 'Validation error message',
};

export const INVALID_START_TIME_TEXT = {
    id: 'oe.meeting.invalidStartTime',
    defaultMessage: 'Invalid Start Time',
    description: 'Validation error message',
};

export const INVALID_END_TIME_TEXT = {
    id: 'oe.meeting.invalidEndTime',
    defaultMessage: 'Invalid End Time',
    description: 'Validation error message',
};

export const CANNOT_BE_EQUAL_OR_GREATER_TEXT = {
    id: 'oe.startEndTime.cannotBeEqualOrGreater',
    description: 'Error label text',
    defaultMessage: 'Start time cannot be equal or greater than End time',
};

export const FIELD_IS_REQUIRED_TEXT = {
    description: 'Warning message',
    defaultMessage: '{field} is required',
    id: 'oe.common.fieldIsRequired',
};
